import { useQuery } from "@apollo/client/react";
import { useAuth0 } from "@auth0/auth0-react";
import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router";

import { constantsData, urlsData } from "@/data";
import { getBulkUpdateStatusQuery } from "@/graph";
import { openAlert } from "@/redux/actions";
import { displayErrorHandler } from "@/utils";

const useGetBulkUpdateReleaseStatus = (id) => {
    const { isAuthenticated } = useAuth0();
    const navigate = useNavigate();
    const { t } = useTranslation();
    const dispatch = useDispatch();

    const { data, error, loading, startPolling, stopPolling } = useQuery(getBulkUpdateStatusQuery, {
        skip: !isAuthenticated,
        variables: {
            jobId: id,
        },
    });

    useEffect(
        () => {
            if (!data?.getReleaseBulkUpdateStatus) {
                if (!loading) navigate(urlsData.routes.notFound);
                return;
            }
            if (data.getReleaseBulkUpdateStatus.status === "completed") stopPolling();
        },
        [data, loading], // eslint-disable-line
    );

    useEffect(() => {
        if (error?.message === constantsData.failedToFetch && !loading) {
            displayErrorHandler(t("messages.networkFailure"), dispatch, openAlert);
        }
    }, [error]); // eslint-disable-line

    useEffect(() => {
        if (
            data?.getReleaseBulkUpdateStatus?.status &&
            data.getReleaseBulkUpdateStatus.status !== "completed" &&
            data.getReleaseBulkUpdateStatus.status !== "failed"
        )
            startPolling(3000);

        // Cleanup: stop polling on unmount
        return () => {
            stopPolling();
        };
    }, [data?.getReleaseBulkUpdateStatus?.status, startPolling, stopPolling]);

    return {
        data: data?.getReleaseBulkUpdateStatus,
        loading,
    };
};

export default useGetBulkUpdateReleaseStatus;
